<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title class="col-12 mb-1">{{$t('campaigns.contents')}}</b-card-title>
        <b-button-group class="body-button-center hide-dropdown-views media-filters">
          <b-button 
            :class="btn_action === 'all' ? 'button-outline-header-grid-active' : 'button-outline-header-grid-no-active'" 
            :variant="btn_action === 'all' ? 'button-outline-header-grid-active' : 'button-outline-header-grid-no-active'" 
            @click="btn_action = 'all'"
          >
          <span> {{ $t('campaigns.allPost') }} </span>
          </b-button>

          <b-button 
            :class="btn_action === 'post' ? 'button-outline-header-grid-active ml-05' : 'button-outline-header-grid-no-active ml-05'" 
            :variant="btn_action === 'post' ? 'button-outline-header-grid-active' : 'button-outline-header-grid-no-active'" 
            @click="btn_action = 'post'"
          >
          <span> {{ $t('campaigns.post') }} </span>
          </b-button>

          <b-button 
            :class="btn_action === 'video' ? 'button-outline-header-grid-active ml-05' : 'button-outline-header-grid-no-active ml-05'" 
            :variant="btn_action === 'video' ? 'button-outline-header-grid-active' : 'button-outline-header-grid-no-active'" 
            @click="btn_action = 'video'"
          >
          <span> {{ $t('campaigns.video') }} </span>
          </b-button>

          <b-button 
            :class="btn_action === 'reels' ? 'button-outline-header-grid-active ml-05' : 'button-outline-header-grid-no-active ml-05'" 
            :variant="btn_action === 'reels' ? 'button-outline-header-grid-active' : 'button-outline-header-grid-no-active'" 
            @click="btn_action = 'reels'"
          >
          <span> Reels </span>
          </b-button>

          <b-button 
            :class="btn_action === 'carousel' ? 'button-outline-header-grid-active ml-05' : 'button-outline-header-grid-no-active ml-05'" 
            :variant="btn_action === 'carousel' ? 'button-outline-header-grid-active' : 'button-outline-header-grid-no-active'" 
            @click="btn_action = 'carousel'"
          >
          <span> Carruseles </span>
          </b-button>
        </b-button-group>

        <div>
         
          <b-dropdown
            no-caret
            right
            variant="transparent"
            class="chart-dropdown mr-1 mt-1"
            toggle-class="p-50"
            size="sm"
          >
          <template #button-content>
            <b-button :class="`button-full-width`" variant="outline-primary" @click="iconShort = !iconShort">
              {{ sortLabel }}
            <b-icon :icon="iconShort ? 'chevron-down': 'chevron-up'"></b-icon> </b-button>
          </template>
       
            <b-dropdown-item
              v-for="sort in sortsDropdown"
              :key="sort.value"
              @click="changeSort(sort)"
            >
              <span>{{ $t(`media_ig.${sort.label}`) }}</span>
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown
            no-caret
            right
            variant="transparent"
            class="chart-dropdown"
            toggle-class="p-50 mt-1"
            size="sm"
          >
          <template #button-content>
            <b-button :class="`button-full-width`" variant="outline-primary" @click="iconDay = !iconDay">
              {{ dayLabel }}
            <b-icon :icon="iconDay ? 'chevron-down': 'chevron-up'"></b-icon></b-button>
          </template>
            <b-dropdown-item
              v-for="day in dayDropdown"
              :key="day.value"
              @click="changeDay(day)"
            >
             <span>{{ $t(`period_media_ig.${day.label}`) }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <b-row class="my-1 text-dark font-weight-bold col-12" v-if="mediaFiltered.length != 0">
          <b-col
            v-for="(item, index) in metricsData"
            :key="index"
            class="d-flex flex-column align-items-start"
          >
            <span class="d-flex align-items-center mb-1">
              {{ $t(item.label) }}
              <feather-icon
                v-if="item.tooltip"
                :id="`tooltip-${index}`"
                icon="HelpCircleIcon"
                size="14"
                class="ml-05 cursor-pointer"
              />
              <b-popover
                :target="`tooltip-${index}`"
                triggers="hover"
                placement="top"
              >
                {{ $t(item.msjTooltip) }}
              </b-popover>
            </span>
            <h3>
              {{ item.value }}
            </h3>
            <div class="d-flex align-items-center">
              <b-badge
                v-if="item.mark"
                :variant="colorBadge(item.mark)"
                pill
                class="badge-circle mr-05"
              >&nbsp;</b-badge>
              <small>{{ traductionMark(item.mark) }}</small>
            </div>


          </b-col>
        </b-row>
        <b-row v-else class="my-1 col-12">
          <b-col class="text-start">
            <h3> N/D</h3>
            <span class="text-muted">{{ $t('campaigns.noDataContent') }}</span>
          </b-col>
        </b-row>  

      </b-card-header>
    </b-card>

    <b-row class="match-height justify-content-center">
      <b-col
        class="col-8 col-sm-6 col-md-5 col-lg-3 mr-lg-2 ml-lg-2 p-lg-0"
        v-for="(media, index) in mediaFiltered" :key="index" 
      >
        <b-card
          no-body
          class="card hover-card card-image-content card-type-content"
        >
          <b-link :href="formatLink(media)" target="_blank">
            <b-img-lazy class="card-image-content" :src="mediaFiltered[index].basic.preview_url" @error.native="errorLoad(index)"/>
          </b-link>
          <div class="card-content-all">
            <div class="container-interactions">
              <b-img  class="icon-network-media" :src="`${getImageNetworkColor('instagram')}`"/>
              <b-avatar class="avatar-style" size="5rem" :src="verifyAsset(media.avatar)"/>
              <span class="influencer-username"> {{ media.username }}
                <image-verified v-if="media.is_verified == true"/>
              </span>
              <span> {{ $t('campaigns.typePost') }}: {{ $t(`campaigns.${media.basic.type}`) }} </span>
              <div class="text-center max-width-100">

                <p class="m-1 text-center max-width-100">
                  {{ shortText(number_words, media.basic.caption) }}
                  <b-link :href="formatLink(media)" target="_blank" class="text-link ml-1 cursor-pointer" v-if="media.basic.caption && media.basic.caption.split(' ').length > number_words">
                    <span :id="`view${index}`">{{$t('instagram.seeMore')}}</span> 
                  </b-link>
                  <b-tooltip :target="`view${index}`" variant="primary" :title="media.basic.caption" placement="bottom" custom-class="tooltip-contents-view" />
                </p>

                <span class="d-flex align-items-center justify-content-center">{{`${getDatev2(new Date(media.basic.time_posted * 1000))}`}}</span>
              </div>
              <div class="col-12 row">
                <div class="mt-1 col-6">
                  <div class="d-flex align-items-center justify-content-center">
                    <b-icon class="mr-1" icon="heart-fill"/>
                    <span>{{ `${media.metrics.likes_count ? getFormat(media.metrics.likes_count) : $t('campaigns.hiddenCreator')}` }}</span>
                  </div>
                </div>
                <div class="mt-1 col-6">
                  <div class="d-flex align-items-center justify-content-center">
                    <b-icon class="mr-1" icon="chat"/>
                    <span>{{ `${media.metrics.comments_count ? getFormat(media.metrics.comments_count) : 0}` }}</span>
                  </div>
                </div>
                <div class="mt-1 col-6" v-if="media.metrics.video_views_count > 0">
                  <div class="d-flex align-items-center justify-content-center">
                    <b-icon class="mr-1" icon="play-circle"/>
                    <span>{{ `${getFormat(media.metrics.video_views_count)}` }}</span>
                  </div>
                </div>
                <div class="mt-1 col-6">
                  <div class="d-flex align-items-center justify-content-center">
                    <b-icon class="mr-1" icon="bar-chart-line"/>
                    <span>{{ media.metrics.er ? `${getFormat(media.metrics.er)} %` : $t('tracking.notAvailable') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BCardHeader, BCardTitle, BDropdown, BDropdownItem, BImg, BImgLazy, BAvatar, BIcon, BLink, BButton, BTooltip, BButtonGroup, BPopover, BBadge} from 'bootstrap-vue';
import { getFormat, shortText } from '@/libs/utils/formats'
import { getDatev2 } from '@/libs/utils/times'
import { getImageNetworkColor } from '@/libs/utils/icons'
import { verifyAsset, } from '@/libs/utils/urls'

export default {
  name: 'InstagramMedia',
  components: {
    BBadge,
    BPopover,
    BButtonGroup,
    BTooltip,
    BButton,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BImg,
    BImgLazy,
    BAvatar,
    BIcon,
    BLink,
    ImageVerified: () => import('@/views/components/image/ImageVerified.vue'),
  },
  props: {
    contents: {
      type: Array,
      default: () => []
    },
    media_ids: {
      type: Object,
      default: () => ({})
    },
    perPage: {
      type: Number,
      default: 5
    },
    avatar: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      btn_action: 'all',
      verifyAsset,
      getFormat,
      getDatev2,
      getImageNetworkColor,
      shortText,
      backgroundDefault: require("@/assets/images/dashboard/imgDefault.png"),
      own_number_words: this.number_words,
      iconShort: true,
      iconDay: true,
      day_selected: 'last_30',
      sort_selected: {
        label: 'most_recent',
        value: 'most_recent'
      },
      number_words: 5,
    }
  },
  computed: {
    sortLabel() {
      const sort = this.sortsDropdown.find(
        (s) => s.value === this.sort_selected.value
      );
      if (!sort) return "";

      return this.$t(`media_ig.${sort.label}`);
    },

    dayLabel() {
      const day = this.dayDropdown.find((d) => d.label === this.day_selected);
      if (!day) return "";

      return this.$t(`period_media_ig.${day.label}`);
    },

    sortsDropdown() {
      return [
        { label: "most_recent", value: "most_recent" },
        { label: "most_engaged", value: "most_engaged" },
        { label: "most_liked", value: "most_liked" },
        { label: "most_commented", value: "most_commented" },
        { label: "most_viewed", value: "most_viewed" },
      ];
    },

    dayDropdown() {
      return [
        { label: "last_30", value: 30 },
        { label: "last_90", value: 90 },
        { label: "last_180", value: 180 },
      ];
    },
    selectedKeys() {
      const type_map = {
        all: 'all',
        post: 'posts',
        video: 'igtv',
        reels: 'reels',
        carousel: 'carousels'
      };
      const sort_map = {
        most_recent: 'time_posted_desc',
        most_engaged: 'er_desc',
        most_liked: 'likes_desc',
        most_commented: 'comments_desc',
        most_viewed: 'views_desc'
      };
      const day_map = {
        last_30: '30d',
        last_90: '90d',
        last_180: '180d'
      };

      return {
        type_selected: type_map[this.btn_action] || 'all',
        sort_selected: sort_map[this.sort_selected.value] || 'time_posted_desc',
        day_selected: day_map[this.day_selected] || '30d'
      };
    },

    mediaFiltered() {
      const { type_selected, sort_selected, day_selected } = this.selectedKeys;
      const ids_filters = this.media_ids?.[type_selected]?.[sort_selected]?.performance?.[day_selected]?.media_ids || [];

      return this.contents.filter(item => ids_filters.includes(item.id));
    },

    metricsData() {
      const { type_selected, sort_selected, day_selected } = this.selectedKeys;
      const metrics = this.media_ids?.[type_selected]?.[sort_selected]?.performance?.[day_selected]?.metrics || {};

      const getVal = (metric, format = true) => {
        if (!metric || metric.value === null) return null;
        return format ? getFormat(metric.value) : metric.value;
      };

      const data = [
        {
          label: 'campaigns.averageLikes',
          msjTooltip: 'campaigns.tooltipAverageLikes',
          value: getVal(metrics.likes_avg, true),
          tooltip: true,
        },
        {
          label: 'campaigns.averageComments',
          msjTooltip: 'campaigns.tooltipAverageComments',
          value: getVal(metrics.comments_avg, true),
          tooltip: false,
        },
        {
          label: 'campaigns.averageViews',
          msjTooltip: 'campaigns.tooltipAverageViews',
          value: getVal(metrics.video_views_avg, true),
          tooltip: true,
        },
        {
          label: 'campaigns.averageER',
          msjTooltip: 'campaigns.tooltipAverageER',
          value: metrics.er_avg?.value !== null ? `${getVal(metrics.er_avg, false)} %` : null,
          mark: metrics.er_avg?.mark ?? null,
          tooltip: true,
        },
      ];

      return data.filter(item => item.value !== null);
    }
  },
  created() {
  },
  methods: {
    traductionMark(mark) {
      if (mark === 'high' || mark === 'very_good' || mark === 'excellent') {
        return this.$t('campaigns.high');
      } else if (mark === 'good') {
        return this.$t('campaigns.good');
      } else if (mark === 'low' || mark === 'fair') {
        return this.$t('campaigns.low');
      } else if (mark === 'average' || mark === 'fair') {
        return this.$t('campaigns.average');
      }
      return '';
    },
    colorBadge(mark) {
      if (mark === 'high' || mark === 'good' || mark === 'very_good' || mark === 'excellent') return 'success';
      if (mark === 'low' || mark === 'fair') return 'warning';
      if (mark === 'average' || mark === 'fair') return 'danger';
      return 'secondary';
    },
    changeSort(sort) {
      this.iconShort = true;
      this.sort_selected = sort;

    },
    changeDay(day) {
      this.iconDay = true;
      this.day_selected = day.label;
    },
    errorLoad(index) {
      this.mediaFiltered[index].basic.preview_url = this.backgroundDefault;
    },
    formatLink(media) {
      return `https://www.instagram.com/p/${media.basic.code}/`
    },
  }
}
</script>

<style>
/* En pantallas chicas los filtros bajan de renglón en lugar de desbordar la página */
@media (max-width: 575px) {
  .media-filters {
    flex-wrap: wrap;
    row-gap: 0.5rem;
  }
}
.badge-circle {
  width: 16px !important;
  height: 16px  !important;
  padding: 0;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
}
.body-button-center{
  position: relative;
  background-color: #F5F8FA;
  padding: .30rem .30rem;
  border-radius: .375rem;
}
.button-outline-header-grid-active {
  background: white;
  padding: 7px 12px;
  border-radius: 6px !important;
}

.button-outline-header-grid-no-active {
  background: transparent;
  padding: 7px 12px;
  border: none;
}
.text-link{
  color: #00cfe8;
}
.text-link:hover{
  color: #00cfe8;
}
.text-link:focus{
  color: #00cfe8;
}
.margin-loader{
  margin-right: 3px;
}
.button-full-width{
  width: 175px !important;
}
.no-results{
  display: flex;
  height: 25%;
  justify-content: center;
}
.hover-card:hover {
  transform: scale(1.05);
  transition: all 500ms;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
    rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
    rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
}
.card-image-content {
  width: 100%;
  object-fit: cover;
  height: 300px;
  border-radius: 1%;
}
.card-content-all {
  width: 100%;
  height: 290px;
}
.card-type-content {
 display: flex;
 height: 90%;
}
.icon-network-media {
  position: relative;
  width: 25px !important;
  height: 25px !important;
  left: 23px;
  bottom: -75px;
  z-index: 2;
}
.container-interactions {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  bottom: 3.3em;
}
.avatar-style {
  padding: 5px;
  background-color: light;
}
.influencer-username {
  margin-top: 1rem;
  font-weight: bold;
}
.max-width-100 {
  max-width: 100%;
}
</style>
